var Algorithm = {
  Ed25519: 2,
  Secp256k1: 1
};
module.exports = Algorithm;